module.exports = __webpack_public_path__ + "img/weibo.df37fbe5.svg";